import React from 'react';
import { Link } from 'react-router-dom'
import { CSSTransition } from 'react-transition-group';

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.scss';

import abcdrop from './img/abcdropicon.png';
import floatywords from './img/floatywordsicon.png';
import noasktask from './img/noasktask/noastaskicon.png';
import readygetready from './img/readysetreadyicontwo.png';
import firstthen from './img/firstthenicon.png';
import snappyshoerace from './img/snappyshoeraceicon.png';
import wobblyabc from './img/wobblyabcicon.png';
import auditattack from './img/auditattackicon.png';
import auditattacktwo from './img/auditattacktwoicon.png';
import cowicon from './img/cowicon.png';


import webopen from './img/webopen.png'
import webopensmall from './img/webopensmall.png'

import burpcowshot from './img/burpcow/openingscreenshottablet.png'
import abcdropshot from './img/ABCDrop/abcdropfour.png'
import floatyshot from './img/FloatyWords/fwactiontwo.png'
import wobblyshot from './img/WobblyABC/beeabc.png'
import firstthenshot from './img/FirstThen/twoscreen.png'
import snappyshot from './img/SSR/litehowplay.png'
import aashot from './img/AuditAttack/openingsmaller.png'
import aatwoshot from './img/AA2/playscreenshot.png'

export const Home = ({}) => {



	return (
		<div className="row padrow">
		<CSSTransition
			in={true}
			appear={true}
			timeout = {2000}
			classNames = "fadeapp"
			>
		<div className="col-md-2 col-lg-2 d-none d-sm-none d-md-block">
			<Link to="/wobblyabc">
				 <img src={ wobblyabc } alt="Wobbly ABC Logo" className="applogo img-responsive d-block mx-auto"/>
				 </Link>
				
				<Link to="/floatywords">
				 <img src={ floatywords } alt="Floaty Words Logo" className="applogo img-responsive d-block mx-auto"/>
				 </Link>
				 <Link to="/burpcow">
				 <img src={ cowicon } alt="Burp the Cow Logo" className="applogo img-responsive d-block mx-auto"/>
				 </Link>
				
	 </div>
	 </CSSTransition>
				<CSSTransition
					in={true}
					appear={true}
					timeout = {1000}
					classNames = "fade"
					>
						<div className="col-xs-12 col-sm-12 col-md-8 col-lg-8">

								 <img src={ webopen } alt="Helen Software Logo" className="d-none d-sm-block mainimage img-responsive mx-auto"/>
								 <div className="d-sm-none d-block mx-auto">
								 	<h3 className="mx-auto d-block centerheader">Wobbly ABC</h3>
									<Link to="/wobblyabc">
									<img src={ wobblyabc } alt="Helen Software Logo" className="smallscreenshot d-sm-none d-block img-responsive mx-auto"/>
									</Link>	 

									
									<h3 className="mx-auto d-block centerheader">Burp the Cow</h3>
									<Link to="/burpcow">
									<img src={ burpcowshot } alt="Helen Software Logo" className="smallscreenshot d-sm-none d-block img-responsive mx-auto"/>
									</Link>
									<h3 className="mx-auto d-block centerheader">FloatyWords</h3>
									<Link to="/floatywords">
									<img src={ floatyshot } alt="Helen Software Logo" className="smallscreenshotp d-sm-none d-block img-responsive mx-auto"/>
									</Link>
									
									
								
									
									<h3 className="mx-auto d-block centerheader">Audit Attack</h3>
									<Link to="/auditattack">
									<img src={ aashot } alt="Helen Software Logo" className="smallscreenshot d-sm-none d-block img-responsive mx-auto"/>
									</Link>
									<h3 className="mx-auto d-block centerheader">Audit Attack Two</h3>
									<Link to="/auditattacktwo">
									<img src={ aatwoshot } alt="Helen Software Logo" className="smallscreenshotp d-sm-none d-block img-responsive mx-auto"/>
									</Link>
								 </div>
					 </div>
					</CSSTransition>
					<CSSTransition
						in={true}
						appear={true}
						timeout = {2000}
						classNames = "fadeapp"
						>
					<div className="col-md-2 col-lg-2 d-none d-sm-none d-md-block">
							
						
							 <Link to="/auditattack">
							 <img src={ auditattack } alt="Audit Attack Logo" className="applogo img-responsive d-block mx-auto"/>
							 </Link>
							 <Link to="/auditattacktwo">
							 <img src={ auditattacktwo } alt="Audit Attack Two Logo" className="applogo img-responsive d-block mx-auto"/>
							 </Link>
				 </div>
				 	</CSSTransition>

	  </div>
			)


}
